import { Accordion, SelectField, ToggleField } from '@ubeya/shared-web/components';
import React, { useContext } from 'react';
import { useField } from 'react-final-form';
import DateField from '@ubeya/shared-web/components/FormFields/DateField';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { required } from '@ubeya/shared/utils/form';
import { FieldsContainer, SectionContent } from '../styled';

const Settings = () => {
  const { t } = useContext(ConfigContext);

  const {
    input: { value: generationMethod }
  } = useField('invoicing.generationMethod');

  const {
    input: { value: groupBy }
  } = useField('invoicing.groupBy');

  const {
    input: { value: sendMethod }
  } = useField('invoicing.sendMethod');

  const isAutomatic = generationMethod === 'automatic';

  return (
    <Accordion defaultOpenRows={{ 0: true }}>
      <Accordion.Item title={t('invoicingSettings__settings')}>
        <SectionContent>
          <FieldsContainer $count={2}>
            <SelectField
              name="invoicing.generationMethod"
              title={t('invoicingSettings__invoicingGenerationMethod')}
              isMulti={false}
              value={generationMethod}
              placeholder=""
              options={[
                { label: 'Automatic', value: 'automatic' },
                { label: 'Manual', value: 'manual' }
              ]}
            />
            <DateField
              showInitialErrorWithoutTouch
              title={t('invoicingSettings__invoicingStartDate')}
              name="invoicing.startedAt"
            />
            {isAutomatic && (
              <>
                <SelectField
                  name="invoicing.groupBy"
                  title={t('invoicingSettings__invoicingGroupBy')}
                  isMulti={false}
                  value={groupBy}
                  placeholder=""
                  required
                  validate={required}
                  options={[
                    { label: 'Project', value: 'project' },
                    { label: 'Date', value: 'date' },
                    { label: 'Employee', value: 'employee' },
                    { label: 'Position', value: 'position' },
                    { label: 'Location', value: 'location' }
                  ]}
                />
                <SelectField
                  name="invoicing.sendMethod"
                  title={t('invoicingSettings__invoicingSendMethod')}
                  isMulti={false}
                  value={sendMethod}
                  placeholder=""
                  required
                  validate={required}
                  options={[
                    { label: 'Once a week', value: 'once-a-week' },
                    { label: 'Once a month', value: 'once-a-month' },
                    { label: 'BI weekly', value: 'bi-weekly' }
                  ]}
                />
                <ToggleField
                  name="invoicing.allowManualGeneration"
                  text={t('invoicingSettings__invoicingAllowManualGeneration')}
                />
              </>
            )}
          </FieldsContainer>
        </SectionContent>
      </Accordion.Item>
    </Accordion>
  );
};

export default Settings;
